module.exports = __webpack_public_path__ + "img/about_4.49ee231b.jpg";